import React from "react";
import { useSelector } from "react-redux";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { muiTheme } from "./muiTheme";
import { isVodexLoggedin } from "./components/NewDevelopment/CommonComponents/Common";

interface Props {
  children: React.ReactNode;
}

const ThemeWrapper: React.FC<Props> = ({ children }) => {
  const whitelabelDetails = useSelector(
    (state: any) => state?.AccountReducer?.whitelabelDetails
  );
  const brandColor =
    (isVodexLoggedin() && "#FF6A00") || whitelabelDetails?.color || "#25304c";

  return (
    <ThemeProvider theme={muiTheme(brandColor)}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default ThemeWrapper;
